export class ObjectNumber {
  private numericValue = 0
  private powValue = 0

  constructor(value = 0) {
    const a = value.toString(10).split('.')
    if (a.length > 1) {
      this.powValue = a[1].length
    }
    this.numericValue = parseInt(a.join(''), 10)
  }

  private cleanup() {
    let str = this.value.toString(10)
    if (str.includes('e')) {
      const a = str.split('e+')
      const amount = parseInt(a[1], 10)

      this.powValue = amount - this.powValue
      this.numericValue = parseFloat(a[0])
      str = a[0]
    }

    if (str.includes('.')) {
      const numVal = Math.pow(10, this.powValue) * this.numericValue
      const num = ObjectNumber.fromNumber(numVal)
      this.numericValue = num.value
      this.powValue = num.factor
    }
  }

  public static fromNumber(value = 0): ObjectNumber {
    return new ObjectNumber(value)
  }

  public static fromObjectNumber(value: ObjectNumber = new ObjectNumber(0)): ObjectNumber {
    return new ObjectNumber().add(value)
  }

  public expand(by: number) {
    this.powValue = this.powValue + by
    this.numericValue = this.numericValue * Math.pow(10, by)
  }

  get value(): number {
    return this.numericValue
  }

  get factor(): number {
    return this.powValue
  }

  private match(anotherNumber: ObjectNumber): void {
    if (anotherNumber.factor < this.factor) {
      anotherNumber.expand(this.factor - anotherNumber.factor)
    }

    if (this.powValue < anotherNumber.factor) {
      this.expand(anotherNumber.factor - this.factor)
    }
  }

  public reset(): this {
    this.numericValue = 0
    return this
  }

  public add(...value: Array<number | ObjectNumber>): this {
    for (let numberLike of value) {
      if (typeof numberLike === 'number') {
        numberLike = new ObjectNumber(numberLike)
      }

      this.match(numberLike)
      this.numericValue = this.numericValue + numberLike.value
    }
    return this
  }

  public subtract(...value: Array<number | ObjectNumber>): this {
    for (let numberLike of value) {
      if (typeof numberLike === 'number') {
        numberLike = new ObjectNumber(numberLike)
      }

      this.match(numberLike)

      this.numericValue = this.numericValue - numberLike.value
    }
    return this
  }

  public multiply(...value: Array<number | ObjectNumber>): this {
    for (let numberLike of value) {
      if (typeof numberLike === 'number') {
        numberLike = new ObjectNumber(numberLike)
      }

      this.numericValue = this.numericValue * numberLike.value
      this.powValue = this.powValue + numberLike.factor
    }

    this.cleanup()
    return this
  }

  public divide(...value: Array<number | ObjectNumber>): this {
    for (let numberLike of value) {
      if (typeof numberLike === 'number') {
        numberLike = new ObjectNumber(numberLike)
      }

      if (numberLike.toNumber() === 0) {
        continue
      }
      this.match(numberLike)
      this.numericValue = this.numericValue / numberLike.value
      const num = ObjectNumber.fromNumber(this.numericValue)
      this.numericValue = num.value
      this.powValue = num.factor
    }

    return this
  }

  public copy(): ObjectNumber {
    return ObjectNumber.fromObjectNumber(this)
  }

  public toString(): string {
    return (this.numericValue * Math.pow(10, this.powValue)).toString(10)
  }

  public toNumber(precision = 2): number {
    const isNegative = this.numericValue < 0
    let stringValue = Math.abs(this.numericValue).toString(10)
    while (stringValue.length < this.powValue) {
      stringValue = '0' + stringValue
    }
    const stringDecimals = stringValue.slice(stringValue.length - this.powValue)
    const floatValue = parseFloat(stringValue.slice(0, stringValue.length - this.powValue) + '.' + stringDecimals)
    const divider = Math.pow(10, precision)
    let result = Math.round(floatValue * divider) / divider
    if (isNegative) {
      result *= -1
    }
    return result
  }
}
